/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartBarsXyVIcon16Regular = forwardRef('DataChartBarsXyVIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M1.75 1.75a.75.75 0 0 0-1.5 0V12.5a2.25 2.25 0 0 0 2.25 2.25h11.75a.75.75 0 0 0 0-1.5H2.5a.75.75 0 0 1-.75-.75V1.75Z" }),
        React.createElement("path", { d: "M13 1.25a.75.75 0 0 1 .75.75v9a.75.75 0 0 1-1.5 0V2a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M7.75 4a.75.75 0 0 0-1.5 0v7a.75.75 0 0 0 1.5 0V4Z" }),
        React.createElement("path", { d: "M10 5.25a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V6a.75.75 0 0 1 .75-.75Z" }),
        React.createElement("path", { d: "M4 7.25a.75.75 0 0 1 .75.75v3a.75.75 0 0 1-1.5 0V8A.75.75 0 0 1 4 7.25Z" })));
});
